import React from 'react';
import Center from './alignment/Center';

interface LoadingIndicatorProps {
  className?: string;
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ className = '' }) => {
  return <p className={'font-raleway text-coffee ' + className}>Loading...</p>;
};

export const LoadingIndicatorLarge = () => {
  return <LoadingIndicator className='text-5xl'></LoadingIndicator>;
};

const LoadingPage = () => {
  return (
    <Center>
      <LoadingIndicatorLarge></LoadingIndicatorLarge>
    </Center>
  );
};

export default LoadingPage;
